import { DealLineItem, DealProduct, PRICING_STRATEGY, PRICING_STRATEGIES } from '@schuettflix/interfaces';

type PriceConfiguration = Pick<DealLineItem, 'materialPrice' | 'transportPrice' | 'francoPrice'>;

function matchPricingStrategyByDealPrices(prices: PriceConfiguration): PRICING_STRATEGY | null {
    if (prices.francoPrice === null && prices.materialPrice === null && prices.transportPrice !== null) {
        return PRICING_STRATEGIES.STANDARD;
    }
    if (prices.francoPrice === null && prices.materialPrice !== null && prices.transportPrice === null) {
        return PRICING_STRATEGIES.STANDARD;
    }
    if (prices.francoPrice !== null && prices.materialPrice === null && prices.transportPrice === null) {
        return PRICING_STRATEGIES.MERCHANT;
    }
    if (prices.francoPrice === null && prices.materialPrice !== null && prices.transportPrice !== null) {
        return PRICING_STRATEGIES.FRANCO;
    }
    return null;
}

export function matchPricingStrategyByDealPricesAndProductType(
    prices: PriceConfiguration,
    productType: DealProduct['productType']
): PRICING_STRATEGY | null {
    const pricingStrategyIndicatedByPrices = matchPricingStrategyByDealPrices(prices);

    if (!pricingStrategyIndicatedByPrices) {
        return null;
    }

    if (['FRANCO', 'MERCHANT'].includes(pricingStrategyIndicatedByPrices)) {
        if (productType === null) {
            return null;
        }
        if (productType.includes('SERVICE')) {
            return PRICING_STRATEGIES.STANDARD;
        }
    }

    return pricingStrategyIndicatedByPrices;
}
